import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {FormControl} from '@angular/forms';
import {ApiVisa, CompanyService, Pagination} from 'blg-akaun-ts-lib';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {DropDownService} from '../../services/drop-down-service';

@Component({
  selector: 'blg-select-company-drop-down-v2',
  templateUrl: './select-company-drop-down-v2.component.html',
  styleUrls: ['./select-company-drop-down-v2.component.scss']
})

export class SelectCompanyDropDownV2Component implements OnInit, OnDestroy {

  @Input() apiVisa: ApiVisa;
  @Input() company = new FormControl(null);
  @Input() required: boolean;
  @Input() userPermissionTarget: Observable<any[]>;
  @Input() readPermissionDefintion: string;

  @Output() companyChange = new EventEmitter<FormControl>();
  @Output() companySelected = new EventEmitter<any>();
  @Input() controlName: string;

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedCompany: any;
  filteredCompany: any = [];
  pagination = new Pagination();

  protected _onDestroy = new Subject<void>();

  constructor(
    private companyService: CompanyService,
    private dropDownService: DropDownService,
  ) {
  }

  ngOnInit() {
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCompany();
      });

    this.userPermissionTarget.subscribe(targets => {
      const target = targets.filter(
        (target) =>
          target.permDfn === this.readPermissionDefintion
      );
      const rawComp = (target[0]?.target !== null && Object.keys(target[0]?.target || {}).length !== 0)
        ? target[0]?.target["bl_fi_mst_comp"]
        : [];

      const compGuid = Array.isArray(rawComp) ? rawComp : rawComp ? [rawComp] : [];
      this.getCompany(compGuid);
    });

    this.company.markAsTouched();
  }

  getCompany(compGuid) {
    let formData = {
      limit: null,
      orderBy: 'code',
      order: 'ASC',
    };

    if (compGuid.length > 0) {
      Object.assign(formData,
        {
          'filterConditions': [
            {
              'filterColumn': 'guid',
              'filterValues': compGuid,
              'filterOperator': 'IN'
            }]
        }
      );
    }

    this.dropDownService
      .get('company', formData, this.apiVisa)
      .pipe(
        map((resolved) => {
          this.filteredCompany = resolved.data;

          if (resolved.data.length === 1) {
            this.company.setValue(resolved.data[0].guid);
          }

          // sorting
          const sorted = this.filteredCompany.sort((a, b) =>
            a.code < b.code ? -1 : 1
          );

          this.filteredOptions$.next(this.filteredCompany.slice());
        })
      )
      .subscribe();
  }

  filterCompany() {
    if (!this.filteredCompany) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.filteredCompany.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter
    this.filteredOptions$.next(
      this.filteredCompany.filter((option) =>
          (option.code ?
            option.code.toLowerCase().indexOf(search) > -1 : null) ||
          (option.name ?
            option.name.toLowerCase().indexOf(search) > -1 : null)
      )
    );
  }

  onSelect(companyGuid: string) {
    if (companyGuid) {
      this.company.patchValue(companyGuid);
      this.selectedCompany = this.filteredCompany.find(row => row.guid === companyGuid);
      this.companySelected.emit(this.selectedCompany);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
